import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function ExportSms({ getParams, total }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (total > 100000 && !window.confirm(`Filter ini berisi ${total.toLocaleString("id-ID")} SMS. Hanya 100.000 terbaru yang diekspor. Lanjut?`)) return;
    setBusy(true);
    try {
      const r = await api.get("/sms/export", { params: getParams(), responseType: "blob", timeout: 300000 });
      const name = (r.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || "sms.xlsx";
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = name;
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success(`${Number(r.headers["x-row-count"] || 0).toLocaleString("id-ID")} SMS diekspor`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button data-testid="sms-export" variant="outline" size="sm" onClick={run} disabled={busy || !total} title="Unduh SMS sesuai filter sebagai Excel">
      {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <FileDown className="h-4 w-4 mr-1 text-emerald-700" />}Ekspor Excel
    </Button>
  );
}
